<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-money fa-lg"></i> {{ $t('project.investment.form.title') }}
        <createButton v-if="canCreateInvestmentCompany" name="investments_company_create" :title="$t('project.investment.company.create.title')"></createButton>
        <createButton v-if="canCreateInvestmentProperty" name="investments_property_create" :title="$t('project.investment.property.create.title')"></createButton>
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>
       
        <div class="table-responsive">
          <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th class="export">{{ $t('project.investment.form.id') }}</th>

                <th>{{ $t('project.investment.form.project') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.company.round') }}</th>
                <th>{{ $t('project.investment.form.totalQuantityAnges') }}</th>
                <th class="export">{{ $t('project.investment.form.totalQuantityAngesJr') }}</th>
                <th class="export">{{ $t('project.investment.form.totalQuantityPartenaires') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.investment.form.region') }}</th>

                <th class="export">{{ $t('project.investment.form.user') }}</th>
                
                <th class="export">{{ $t('project.investment.form.aqcAmount') }}</th>

                <th class="export">{{ $t('project.investment.form.category') }}</th>
                <th class="export">{{ $t('project.investment.form.type') }}</th>

                <th class="export">{{ $t('project.investment.form.totalValueAnges') }}</th>
                <th class="export">{{ $t('project.investment.form.totalValueAngesJr') }}</th>
                <th class="export">{{ $t('project.investment.form.totalValuePartenaires') }}</th>

                <th>{{ $t('project.investment.form.totalValue') }}</th>
                <th class="date-range-filter">{{ $t('project.investment.form.dateOfInvestissement') }}</th>
                <th class="no-sort no-filter" width="100" v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th class="export">{{ $t('project.investment.form.id') }}</th>

                <th>{{ $t('project.investment.form.project') }}</th>
                <th class="drop-down-filter">{{ $t('project.investment.form.company.round') }}</th>
                <th>{{ $t('project.investment.form.totalQuantityAnges') }}</th>
                <th class="export">{{ $t('project.investment.form.totalQuantityAngesJr') }}</th>
                <th class="export">{{ $t('project.investment.form.totalQuantityPartenaires') }}</th>
                
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.investment.form.region') }}</th>

                <th class="export">{{ $t('project.investment.form.user') }}</th>
                
                <th class="export">{{ $t('project.investment.form.aqcAmount') }}</th>

                <th class="export">{{ $t('project.investment.form.category') }}</th>
                <th class="export">{{ $t('project.investment.form.type') }}</th>

                <th class="export">{{ $t('project.investment.form.totalValueAnges') }}</th>
                <th class="export">{{ $t('project.investment.form.totalValueAngesJr') }}</th>
                <th class="export">{{ $t('project.investment.form.totalValuePartenaires') }}</th>

                <th>{{ $t('project.investment.form.totalValue') }}</th>
                <th>{{ $t('project.investment.form.dateOfInvestissement') }}</th>
                <th class="no-sort no-filter" width="100" v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="entite in entites" v-bind:data-id="entite.id" :key="entite.id" @click="view(entite)" class="clickable-row">
                <td>{{ entite.id }}</td>
                <td>
                   {{ entite.project.entreprise.name }}
                   <span class='imported_alert' v-if='entite.imported'>**</span>
                </td>
                <td>{{ entite.round }}</td>
                <td>{{ entite.quantityAngels }}</td>
                <td>{{ entite.aqjQuantity }}</td>
                <td>{{ entite.quantityPartners }}</td>
                <td>{{ entite.project.aLaCarte ? $t('project.company.form.aLaCarte') : entite.project.projectTypeText }}</td>
                <td>{{ entite.regionText }}</td>

                <td>{{ entite.user != null ? entite.user.fullName : "" }}</td>
               
                <td>{{ entite.aqcAmount }}</td>
                
                <td>{{ entite.categoryText }}</td>
                <td>{{ entite.typeText }}</td>

                <td>{{ entite.amountAngels }}</td>
                <td>{{ entite.aqjAmount }}</td>
                <td>{{ entite.amountPartners }}</td>

                <td>{{entite.totalValue }}</td>
                <td>{{entite.dateOfInvestissement | formatDate }}</td>

                <td class="no-sort" align=center v-if="canCreate || canDelete">
                  <div v-if="entite.project.companyStatus == 1">
                    <a href="#" v-if="canReallyCreate(entite)" v-bind:title="$t('form.edit_button')" v-on:click.stop="edit(entite)">
                      <span class="fa fa-lg fa-pencil"></span>
                    </a>
                    <a href="#" v-else v-bind:title="$t('form.edit_button')">
                      <span class="fa fa-lg fa-pencil text-muted"></span>
                    </a>
                    &nbsp;
                    <a class="text-danger" v-if="canReallyDelete(entite)" v-bind:title="$t('form.delete_button')" href="#" v-on:click.stop="deleteEntity(entite.id)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                    <a class="text-danger" v-else v-bind:title="$t('form.delete_button')">
                      <span class="fa fa-lg fa-trash text-muted"></span>
                    </a>
                  </div>
                  <div v-if="entite.project.companyStatus == 0">
                    <span class="fa fa-lg fa-pencil text-muted"></span>
                    &nbsp;
                    <span class="fa fa-lg fa-trash text-muted"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {InvestmentServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'
import permission from '../../shared/permission'

export default {
  name: 'Investments',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: InvestmentServiceClient,
    }
  },
  computed: {
    canCreateInvestmentProperty: function() {
      return permission.checkPermission(['Pages.Projects.Property.Create'])
    },
    canCreateInvestmentCompany: function() {
      return permission.checkPermission(['Pages.Projects.Company.Create'])
    },
  },
  methods: {
    canReallyCreate: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Create'
      if (entite.project.projectType == 1) validatePermission = 'Pages.Projects.Company.Create'

      return (
        (permission.checkPermission([validatePermission]) || permission.checkPermission(['Pages.Members.Junior.Seulement'])) &&
        this.canCreate
      )
    },
    canReallyDelete: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Delete'
      if (entite.project.projectType == 1) validatePermission = 'Pages.Projects.Company.Delete'

      return permission.checkPermission([validatePermission]) && this.canDelete
    },
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let self = this

      let projectId = this.$route.params.project_id
      let investmentType = undefined

      service
        .getAll(projectId, investmentType, '', 0, 10000)
        .then(res => {
          self.entites = res.items
          self.showDataTable()
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })
    },
    view: function(entite) {
      this.redirectTo(entite, 'view')
    },
    edit: function(entite) {
      this.redirectTo(entite, 'edit')
    },
    copy: function(entite) {
      this.redirectTo(entite, 'copy')
    },
    redirectTo: function(entite, mode) {
      var route = entite.project.projectType != 1 ? 'property' : 'company'
      this.$router.push({
        name: 'investments_' + route + '_' + mode,
        params: {id: entite.id},
      })
    },
    totalDeboursement: function(entite) {
      let totalValues = _.sumBy(entite.investmentValues, function(x) {
        return parseInt(x.value)
      })
      return totalValues === parseInt(entite.totalValue)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .dataTables_wrapper{
    padding: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Investment/Investment.vue